// extracted by mini-css-extract-plugin
export default {"coloredNotch":"ColoredNotch_coloredNotch__crZ7F","background":"ColoredNotch_background__aLRN0","backgroundAlt":"ColoredNotch_backgroundAlt__BK6SY"};